import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import { Store } from '@ngrx/store';
import { Club } from '../../modal';

import * as ActionClub from './action';

@Injectable()
export class ClubEffects {
  constructor(private store: Store<RootStoreState.State>, private actions$: Actions) {}

  loadAction$ = createEffect(() => this.actions$
    .pipe(
      ofType<ActionClub.PostClubRequest>(ActionClub.POST_Club),
      map(action => {return action.payload as any}),
      
    ));
  private handleError(error) {
    return of(new ActionClub.Error(error));
  }
}
